import { Utils } from '@genial/utils';

import { InputMoneyProps } from '../../../components/InputMoney';
import { AddedProductItemDirectTreasuryProps } from '../components/Cart/components/AddedProductItem/DirectTreasury';
import { useDirectTreasuryAssetController } from '../components/DynamicAsset/hooks/products/DirectTreasury';

import { useBatchTicketCartActionItem } from './batchTicketCartActionItem';

interface useDirectTreasuryAddedProductItemProps extends AddedProductItemDirectTreasuryProps {}

export const useDirectTreasuryAddedProductItem = ({
  data: item,
  type,
}: useDirectTreasuryAddedProductItemProps) => {
  const inputIsDisabled = type === 'requiredAttention';

  const { isLoadingAction, onRemoveProduct, onUpdateProduct } =
    useBatchTicketCartActionItem<'directTreasury'>({
      item,
      id: 'directTreasury',
      idSelector: 'productId',
      type,
    });

  const {
    control,
    amountItem,
    handleChangeAmountItem,
    handleInputBlur,
    handleInputClear,
    handleInputFocus,
    handleSubmit,
    hasError,
    helpText,
    helpTextProps,
    isFocused,
    showMessageAdjustUnitPrice,
    currentValueFormatted,
  } = useDirectTreasuryAssetController(item, onUpdateProduct);

  const isRequiredAttention = type === 'requiredAttention';
  const isTotalSummary = type === 'totalSummary';
  const useAmountValue = (isRequiredAttention || isTotalSummary) && item.amount;
  const useQuantityValue = (isRequiredAttention || isTotalSummary) && item.quantity;
  const currentValue = useAmountValue ? Utils.Mask.Money(item.amount) : currentValueFormatted;
  const quantityAmount = useQuantityValue ? item.quantity! : amountItem;

  const inputMoneyDataProps = {
    id: `product-added-applied-amount-${item.offerId}`,
    name: 'priceItem',
    control,
    handleFocus: handleInputFocus,
    handleBlur: handleInputBlur,
    handleSubmit,
    handleClear: handleInputClear,
    isDisabled: inputIsDisabled,
    currentValue,
    hasFocus: isFocused,
    minValue: item.minimumApplication,
    customInputProps: {
      ...{
        ...(showMessageAdjustUnitPrice && {
          helpTextProps,
          helpText,
        }),
      },
      ...(isFocused && hasError && { error: hasError }),
      ...(isFocused && !hasError && { helpText }),
    },
  } as InputMoneyProps;

  return {
    inputMoneyDataProps,
    messageAdjustUnitPriceIsVisible: showMessageAdjustUnitPrice,
    amountItem: quantityAmount,
    inputIsFocused: isFocused,
    onRemoveProduct,
    handleChangeAmountItem,
    isLoadingAction,
    inputIsDisabled,
  };
};
